import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)
import * as THREE from "three"
import {
  debugObject,
  deviceStateManager,
  environment,
  garments,
  loaders,
  overlay,
  pane,
  patch,
  patchFolder,
  scene,
  stencilScene,
} from "./Experience"

export class Garments {
  constructor() {
    this.setTimeLine()
    this.setHoodie()
    this.setTweaks()
    this.testScene()
  }

  setTimeLine() {
    this.tl = gsap.timeline()
  }

  testScene() {
    let cloakGroup = new THREE.Group()
    let insideGroup = new THREE.Group()
    cloakGroup.renderOrder = 1
    scene.add(cloakGroup)
    insideGroup.renderOrder = 2
    scene.add(insideGroup)
  }

  setHoodie() {
    this.hoodieDiffuseTexture = loaders.textureLoader.load(
      "/assets/models/hoodie-diffuse.png"
    )
    this.hoodieDiffuseTexture.flipY = false
    this.hoodieDiffuseTexture.encoding = THREE.sRGBEncoding

    this.hoodieMaterial = new THREE.MeshStandardMaterial({
      // map: this.hoodieDiffuseTexture,
      // color: "#C7BFB7",
    })

    this.crystalMaterial = new THREE.MeshBasicMaterial({
      // color: "white",
      color: debugObject.crystalColor,
      envMap: environment.crystalEnvMap,
      envMapIntensity: 10,
      transparent: true,
      refractionRatio: 0.9,
      blending: THREE.AdditiveBlending,
      stencilWrite: true,
      stencilFunc: THREE.EqualStencilFunc,
      stencilRef: 2,
      // stencilZPass: THREE.ReplaceStencilOp
    })

    loaders.gltfLoader.load(
      "/assets/models/hoodie-update-full-7.gltf",
      (gltf) => {
        this.hoodie = gltf.scene

        this.hoodie.position.set(0.4, 0.05, 0.2)
        this.hoodie.rotation.set(0, Math.PI / 2, 0)

        // this.hoodie.rotation.set(0.18, 0, 0)
        // this.hoodie.position.set(0, 0.14, 0.85)

        this.hoodieMesh = this.hoodie.getObjectByName("Hoodie")

        // this.patchMesh = this.hoodie.getObjectByName("Patch")
        // this.patchMesh.material.emissive = new THREE.Color(0xffffff)

        this.hoodieMesh.traverse((child) => {
          // child.material = this.hoodieMaterial
        })

        this.patchBackground = this.hoodie.getObjectByName("PatchBackground")
        this.patchBackground.renderOrder = 4

        this.patchCrystal = this.hoodie.getObjectByName("PatchCrystal")
        this.patchCrystal.material = this.crystalMaterial
        //Not sure why this works with 2 it should be 1
        this.patchCrystal.renderOrder = 3

        this.patchGraphic = this.hoodie.getObjectByName("PatchGraphic")
        this.patchGraphic.renderOrder = 4
        this.patchGraphic.material.stencilWrite = true
        this.patchGraphic.material.stencilFunc = THREE.NotEqualStencilFunc
        this.patchGraphic.material.stencilRef = 2

        // this.patchMask = this.hoodie.getObjectByName("PatchMask")
        // this.patchMask.material.colorWrite = false
        // this.patchMask.renderOrder = 1

        this.patchCircle = this.hoodie.getObjectByName("PatchCircle")
        this.patchCircle.renderOrder = 1
        // this.patchCircle.visible = false;

        //Empty object to copy position from
        this.patchParticles = this.hoodie.getObjectByName("PatchParticles")

        this.patchStencil = this.hoodie.getObjectByName("PatchStencil")

        this.patchStencil.material = new THREE.MeshBasicMaterial({
          color: 0xff00ff,
          side: THREE.FrontSide,
          colorWrite: false,
          depthWrite: false,
          stencilWrite: true,
          stencilFunc: THREE.GreaterEqualStencilFunc,
          stencilRef: 1,
          stencilZPass: THREE.IncrementWrapStencilOp,
        })
        this.patchStencil.renderOrder = 2

        this.hoodieMesh.material.stencilWrite = true
        this.hoodieMesh.material.stencilFunc = THREE.NotEqualStencilFunc
        this.hoodieMesh.material.stencilRef = 2
        // this.hoodieMesh.material.stencilZPass =  THREE.ReplaceStencilOp;
        this.hoodieMesh.renderOrder = 4

        let tag = this.hoodie.getObjectByName("PatchTag")
        tag.material.stencilWrite = true
        tag.material.stencilRef = 1
        tag.material.stencilFunc = THREE.EqualStencilFunc
        tag.renderOrder = 1
        tag.material.map.minFilter = THREE.LinearMipmapLinearFilter

        let text = this.hoodie.getObjectByName("PatchText")
        text.material.stencilWrite = true
        text.material.stencilRef = 2
        text.material.stencilFunc = THREE.EqualStencilFunc
        text.renderOrder = 1
        text.material.map.minFilter = THREE.LinearMipmapLinearFilter

        this.patchCircle.material.stencilWrite = true
        this.patchCircle.renderOrder = 4
        this.patchCircle.material.stencilRef = 2
        this.patchCircle.material.stencilFunc = THREE.EqualStencilFunc
        scene.add(this.hoodie)

        this.setHoodieAnimations()

        // pane.addInput(this.hoodie.rotation, "x", {
        //   min: -Math.PI,
        //   max: Math.PI,
        //   step: 0.01,
        //   label: "Hoodie Rotation X",
        // })

        // pane.addInput(this.hoodie.rotation, "y", {
        //   min: -Math.PI * 2,
        //   max: Math.PI * 2,
        //   step: 0.01,
        //   label: "Hoodie Rotation Y",
        // })

        // pane.addInput(this.hoodie.position, "y", {
        //   min: 0,
        //   max: 2,
        //   step: 0.01,
        //   label: "Hoodie Position Y",
        // })

        // pane.addInput(this.hoodie.position, "z", {
        //   min: 0,
        //   max: 2,
        //   step: 0.01,
        //   label: "Hoodie Position Z",
        // })
      }
    )
  }

  copyShadersToMeshes() {
    let particlesWorldPosition = new THREE.Vector3()
    // let connectorWorldPosition = new THREE.Vector3()
    this.patchParticles.getWorldPosition(particlesWorldPosition)
    patch.patchParticlesPoints.position.copy(particlesWorldPosition)
    patch.patchParticlesPoints.rotation.copy(this.hoodie.rotation)
    // this.patchConnectorMesh.getWorldPosition(connectorWorldPosition)
    // patch.patchConnector.position.copy(connectorWorldPosition)
    // patch.patchConnector.rotation.copy(this.hoodie.rotation)
  }

  setHoodieAnimations() {
    let scrubAmount = 0.5

    ScrollTrigger.defaults({
      immediateRender: false,
      ease: "power1.inOut",
    })

    // //!1
    // if (deviceStateManager.state === "desktop") {
    //   this.tl.fromTo(
    //     this.hoodie.position,
    //     {
    //       x: 0.5,
    //       scrollTrigger: {
    //         trigger: ".scroll-area-1",
    //         scrub: scrubAmount,
    //         start: "top bottom",
    //         end: "center center",
    //       },
    //     },
    //     {
    //       x: 0,
    //       scrollTrigger: {
    //         trigger: ".scroll-area-1",
    //         scrub: scrubAmount,
    //         start: "top bottom",
    //         end: "center center",
    //       },
    //     }
    //   )
    // }

    // this.tl.to(this.hoodie.rotation, {
    //   y: 0.9,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-1",
    //     scrub: scrubAmount,
    //     start: "top bottom",
    //     end: "center center",
    //   },
    // })

    // //!2
    // this.tl.to(this.hoodie.rotation, {
    //   x: 0.18,
    //   y: 0,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-2",
    //     scrub: scrubAmount,
    //     start: "top bottom",
    //     end: "center center",
    //   },
    // })
    // this.tl.to(this.hoodie.position, {
    //   y: 0.14,
    //   z: 0.85,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-2",
    //     scrub: scrubAmount,
    //     start: "top bottom",
    //     end: "center center",
    //   },
    // })

    // //!3

    // this.tl.to(this.hoodie.rotation, {
    //   y: -Math.PI * 1.5,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-3",
    //     scrub: scrubAmount,
    //     start: "top bottom",
    //     end: "center center",
    //   },
    // })

    // //!4
    // if (deviceStateManager.state === "desktop") {
    //   this.tl.to(this.hoodie.position, {
    //     x: 0.5,
    //     y: 0,
    //     z: 0,
    //     scrollTrigger: {
    //       trigger: ".scroll-area-3",
    //       scrub: scrubAmount,
    //       start: "top bottom",
    //       end: "center center",
    //     },
    //   })
    // } else {
    //   this.tl.to(this.hoodie.position, {
    //     x: 0,
    //     y: 0,
    //     z: 0,
    //     scrollTrigger: {
    //       trigger: ".scroll-area-3",
    //       scrub: scrubAmount,
    //       start: "top bottom",
    //       end: "center center",
    //     },
    //   })
    // }

    // this.tl.to(this.hoodie.rotation, {
    //   x: 0,
    //   y: -Math.PI * 1.5,
    //   z: 0,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-3",
    //     scrub: scrubAmount,
    //     start: "top bottom",
    //     end: "center center",
    //   },
    // })

    //!NEW
    // this.tl.to(this.hoodie.rotation, {
    //   x: 0.18,
    //   y: 0,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-1",
    //     scrub: scrubAmount,
    //     start: "top bottom",
    //     end: "center center",
    //   },
    // })
    // this.tl.to(this.hoodie.position, {
    //   y: 0.14,
    //   z: 0.85,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-1",
    //     scrub: scrubAmount,
    //     start: "top bottom",
    //     end: "center center",
    //   },
    // })

    this.tl.invalidate()
  }

  setTweaks() {
    patchFolder
      .addInput(debugObject, "crystalColor", { label: "Crystal Color" })
      .on("change", (ev) => {
        this.crystalMaterial.color = new THREE.Color(ev.value)
      })
  }

  rotateCrystal(elapsedTime) {
    this.patchCrystal.rotation.z = -elapsedTime * 0.1
  }
}
